<div>
    <canvas #canvas width="30" height="20"></canvas>
    <span class="name mat-caption">{{legend.name}}</span>
</div>



